import Block from '../../../components/Block/Block'
import Link from '../../../components/Link/Link'
import { useState, useEffect } from 'react'
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext'

import style from './navblock.module.scss'

import bull from '../../../assets/bull.png'

const NavBlock = () => {
    const [isMobile, setIsMobile] = useState(false)
    const settings = useAccessibility()

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.matchMedia('(max-width: 768px)').matches)
        }

        checkScreenSize()
        window.addEventListener('resize', checkScreenSize)
        
        return () => window.removeEventListener('resize', checkScreenSize)
    }, [])

    const links = [
        { href: '/about/main/', text: 'Основные сведения' },
        { href: '/about/structure/', text: 'Структура и органы управления образовательной организацией' },
        { href: '/about/documents/', text: 'Документы' },
        { href: '/about/education/', text: 'Образование' },
        { href: '/about/management/', text: 'Руководство' },
        { href: '/team/', text: 'Педагогический состав' },
        { href: '/about/equipment/', text: 'Материально-техническое обеспечение и оснащенность образовательного процесса. Доступная среда' },
        { href: '/about/services/', text: 'Платные образовательные услуги' },
        { href: '/about/activity/', text: 'Финансово-хозяйственная деятельность' },
        { href: '/about/vacant/', text: 'Вакантные места для приема (перевода) обучающихся' },
        { href: '/about/scholarship/', text: 'Стипендии и меры поддержки обучающихся' },
        { href: '/about/international/', text: 'Международное сотрудничество' },
        { href: '/about/food/', text: 'Организация питания в образовательной организации' },
        { href: '/about/requirements/', text: 'Образовательные стандарты и требования' }
    ]

    return (
        <Block
            width="75%"
            height='fit-content'
            background={settings.contrast === 'default' ? "#1d3e8c" : "rgba(255, 255, 255, 0.85)"}
        >
            <div className={style.content}>
                {/* Декоративные точки */}
                <div className={`${style.decorDots} ${style['decorDots--1']}`}></div>
                <div className={`${style.decorDots} ${style['decorDots--2']}`}></div>
                <div className={`${style.decorDots} ${style['decorDots--3']}`}></div>
                
                <div className={style.left}>
                    <h3 className={style.header}>
                        НАВИГАЦИЯ
                    </h3>
                    
                    {links.map((link, index) => (
                        <div key={index} className={style.wrapperLink}>
                            <Link
                                href={link.href}
                                color="#000000"
                                children={link.text}
                                fontFamily='Roboto, sans-serif'
                                fontSize={isMobile ? '0.8rem' : '1rem'}
                                fontWeight='550'
                                textDecoration='none'
                            />
                        </div>
                    ))}
                </div>
                
                <div className={style.right}>
                    <div className={style.bullWrapper}>
                        {/* Красная подсветка под быком (всегда включена) */}
                        <div className={style.bullGlow}></div>
                        <div className={style.bullGlowExtra}></div>
                        <img className={style.bull} src={bull} alt="Бык" />
                    </div>
                </div>
            </div>
        </Block> 
    )
}

export default NavBlock